__turbopack_context__.v({
  "interactiveMap": "InteractiveMap-module-scss-module__7LeKOq__interactiveMap",
});
